import { View } from "./View";

interface IOnboardingHeaderProps {
  handleComplete: () => void;
  handleCancel: () => void;
  isCompleteEnabled: boolean;
}

export const OnboardingHeader = (props: IOnboardingHeaderProps) => {
  return <View {...props} />;
};
